export default {
    offset: {
        top: 30,
        right: 30,
        bottom: 30,
        left: 30,
    },
    data: {
        volumed: true,
        hover: {
            value: 20,
        },
        styles: {
            width: 80,
            color: '#fff',
        },
    },
    texts: {
        center: {
            enabled: false,
            value: '100%',
            styles: {
                color: '#ffffff',
                fontSize: 30,
            },
        },
        slicePercent: {
            enabled: false,
            styles: {
                color: '#ffffff',
                fontSize: 10,
            },
        },
    },
};
